__turbopack_context__.v({
  "item": "accessories-list-module-scss-module__WDd7GG__item",
  "list": "accessories-list-module-scss-module__WDd7GG__list",
});
